/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	'use strict';
	/*globals Tc */

	/**
	 * MultiDropdownFilterList
	 *
	 * @author Michael Keller
	 * @namespace Tc.Module
	 * @class MultiDropdownFilterList
	 * @extends Tc.Module
	 */
	Tc.Module.MultiDropdownFilterList = Tc.Module.extend({

		on: function(callback) {
			var mod = this,
				$ctx = mod.$ctx;

			mod.currentValues = {};

			$ctx.on('click', '.filterParamRemove', function() {
				mod.fire('removeFilter', { name : jQuery(this).closest('li').find('.breadcrumb-label').data('filterType'), value : jQuery(this).closest('li').find('.breadcrumb-label').data('value')});
				$(this).closest('li').remove();
			});

			$ctx.on('click', '.removeAllFilterButton + .icon-close', function() {
				mod.fire('clearAll');
			});

			callback();
		},


		onUpdateValue: function(data) {
			var mod = this;
			mod.currentValues[data.name] = data;
			mod.renderValues();
		},

		renderValues: function() {
			var mod = this,
				$ctx = mod.$ctx;

			$ctx.find('.filter-breadcrumb li').remove();

			$('.multiselect, .is-mobile select[multiple]').each(function() {
				if (mod.currentValues[jQuery(this).attr('name')]) {
					var data = mod.currentValues[jQuery(this).attr('name')],
						i = 0,
						$li = null,
						$label = null,
						$close = null;
					for (i = 0; data.valueObj && i < data.valueObj.values.length; i++) {
						$li = jQuery('<li />').appendTo(mod.$ctx.find('.filter-breadcrumb'));
						$label = jQuery('<span />').appendTo($li).addClass('breadcrumb-label').data('filterType', data.name).data('value', data.valueObj.values[i]).text(data.valueObj.labels[i]);
						$close = jQuery('<span />').appendTo($li).addClass('filterParamRemove').addClass('icon-close close-icon');
					}
				}
			});

			if ($ctx.find('li').length === 0) {
				$ctx.find('.removeAllFilterButton, .removeAllFilterButton + .icon-close').hide();
			}
			else {
				$ctx.find('.removeAllFilterButton, .removeAllFilterButton + .icon-close').show();
			}

		}

	});
}(Tc.$));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.MultiDropdownFilterList.js
// module id = 155
// module chunks = 0